<ap-button (click)="onOpenConversational()" data-testid="retail-conversational-button">
    {{ 'conversational.link.button.label' | apContent }}
</ap-button>
